import { render, staticRenderFns } from "./EditRadarDialog.vue?vue&type=template&id=236bc2d6"
import script from "./EditRadarDialog.vue?vue&type=script&lang=js"
export * from "./EditRadarDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports